const SELLER_APPLY_RETURN_PATH_KEY = 'SellerApplyReturnPath';

/**
 * Persist a return path so EmailVerificationPage can send the user back
 * to the seller application flow after they click the verify link.
 *
 * @param {string} path relative path including search (e.g. /profile-settings?applySeller=true)
 */
export const saveSellerApplyReturnPath = path => {
  if (typeof window !== 'undefined' && window.localStorage && path) {
    window.localStorage.setItem(SELLER_APPLY_RETURN_PATH_KEY, path);
  }
};

/**
 * @returns {string|null}
 */
export const getSellerApplyReturnPath = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage.getItem(SELLER_APPLY_RETURN_PATH_KEY);
  }
  return null;
};

export const clearSellerApplyReturnPath = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.removeItem(SELLER_APPLY_RETURN_PATH_KEY);
  }
};
